<template>
   <Tables ref="tableGrid"
              :columns="headTable"
              :showSearch="false"
              style="font-family:'Segoe UI'"
              :showPrint="false"
              :showDownload="false"
              :showFullscreen="false"
              v-on:Load="onLoad"
            >
              <tr v-for="comissao in consultacomissao" v-bind:key="comissao.id">
                  <TableColumn :IsText="true"   v-on:Edit="$emit('edit', comissao)" :status="1" :value="comissao.conta.nome" />
                  <TableColumn :IsText="true"   v-on:Edit="$emit('edit', comissao)" :status="1" :value="comissao.credenciada.nome" />
                  <TableColumn :IsText="true"   v-on:Edit="$emit('edit', comissao)" :status="1" :value="comissao.empreendimento.nome" />
                  <TableColumn :IsText="true"   v-on:Edit="$emit('edit', comissao)" :status="1" :value="comissao.dataVendaFormatada" />
                  <TableColumn :IsText="true"   v-on:Edit="$emit('edit', comissao)" :status="1" :value="comissao.proposta.valorTotalFormatado == 0 ? '0' :comissao.proposta.valorTotalFormatado" />
                  <TableColumn :IsText="true"   v-on:Edit="$emit('edit', comissao)" :status="1" :value="toStringCus(comissao.unidadeVendadida)" />
                  <TableColumn :IsText="true"   v-on:Edit="$emit('edit', comissao)" :status="1" :value="comissao.credenciada.percentualComissao" />
                  <TableColumn :IsActionsButtons="true" v-on:Delete ="$emit('deleteCommission', comissao.id)" :status="1" :HasChange = "false"/>
              </tr>
            </Tables>
</template>

<script>
import TableSalesConsultation from './TableSalesConsultation'
export default TableSalesConsultation

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/private/realestate/salesconsultation/components/TableSalesConsultation/TableSalesConsultation.vue